// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"03e7de42","184":"8e69f8a9","319":"bb993098","363":"4ad54585","520":"eb837579","531":"1bc5e574","660":"6902acd7","787":"3b5cfb1c","790":"abf0901c","847":"b71fe470","887":"68afbcfb","932":"b769bf38"}[chunkId] + ".chunk.js";
};